import { sortmentApi } from '@api/index';
import {
    type ApiError,
    type ApiResponse,
    type SubscriptionGroup,
} from '@lightdash/common';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { QueryKeys } from 'types/UseQuery';

const getSubscriptionGroupById = async (projectId: string, groupId: string) => {
    return sortmentApi<ApiResponse>({
        url: `/user-subscription-preferences/subscription-group?subscriptionGroupId=${groupId}&projectId=${projectId}`,
        method: 'GET',
        body: undefined,
    });
};

// in this function we are using projectUuid where there is projectId in url, but in subscription preference we have projectId as queryParams
// so in order to call the api in preferences the projectId is passed  as prop here
export const useGetSubscriptionGroupById = ({
    groupId,
    projectId,
}: {
    groupId: string;
    projectId?: string;
}) => {
    const { projectUuid = '' } = useParams<{ projectUuid: string }>();
    const subscriptionGroup = useQuery<
        ApiResponse,
        ApiError,
        SubscriptionGroup
    >({
        queryKey: [QueryKeys.GET_SUBCRIPTION_GROUP_BY_ID, groupId, projectUuid],
        queryFn: () => {
            if (projectId) return getSubscriptionGroupById(projectId, groupId);
            return getSubscriptionGroupById(projectUuid, groupId);
        },
        retry: false,
        enabled: !!groupId && !!projectId,
    });
    return subscriptionGroup;
};
